(function () {
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  GUARD : une seule instance du moteur
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  if (window.__vxCountdownEngine) {
    // Le moteur existe déjà, on expose juste l'API publique et on sort
    window.startCountdown = window.__vxCountdownEngine.start;
    window.freezeCountdown = window.__vxCountdownEngine.freeze;
    return;
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  UTILS
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  function pad2(n) {
    n = Math.max(0, n | 0);
    return n < 10 ? "0" + n : String(n);
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  BUILD : injecte le HTML dans un .countdown
  //  - appellé une seule fois par élément
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  function buildCountdown(el) {
    if (el.__vxInited) return;
    el.__vxInited = true; // propriété JS, pas d'attribut DOM → plus rapide

    var format = null;
    try { format = JSON.parse(el.getAttribute("data-format")); } catch (e) {}

    var noDays = el.getAttribute("data-no-days") === "false";

    var LANG_LABELS = {
      fr: { d: "J", h: "H", m: "M", s: "S" },
      en: { d: "D", h: "H", m: "M", s: "S" },
      de: { d: "T", h: "H", m: "M", s: "S" },
      nl: { d: "D", h: "U", m: "M", s: "S" },
      it: { d: "G", h: "O", m: "M", s: "S" },
      es: { d: "D", h: "H", m: "M", s: "S" },
    };
    var lang = (document.documentElement.lang || "fr").split("-")[0].toLowerCase();
    var fallback = LANG_LABELS[lang] || LANG_LABELS["fr"];

    var labels = {
      d: (format && format.d) || fallback.d,
      h: (format && format.h) || fallback.h,
      m: (format && format.m) || fallback.m,
      s: (format && format.s) || fallback.s,
    };

    var sep = format ? '<div class="vx-box vx-sep">:</div>' : "";

    el.innerHTML =
      '<div class="vx-countdown">' +
      (!noDays
        ? '<div class="vx-box"><span class="vx-num vx-d">00</span><span class="vx-lab">' + labels.d + "</span></div>" + sep
        : "") +
      '<div class="vx-box"><span class="vx-num vx-h">00</span><span class="vx-lab">' + labels.h + "</span></div>" + sep +
      '<div class="vx-box"><span class="vx-num vx-m">00</span><span class="vx-lab">' + labels.m + "</span></div>" + sep +
      '<div class="vx-box"><span class="vx-num vx-s">00</span><span class="vx-lab">' + labels.s + "</span></div>" +
      "</div>";

    // Cache les refs DOM directement sur l'élément → zéro querySelector dans la boucle de tick
    el.__vx = {
      noDays: noDays,
      d: el.querySelector(".vx-d"),
      h: el.querySelector(".vx-h"),
      m: el.querySelector(".vx-m"),
      s: el.querySelector(".vx-s"),
    };
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  ENGINE : un seul setInterval pour TOUT
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  var endTime = null;   // timestamp ms de fin
  var tickerId = null;  // id du setInterval unique

  function tick() {
    if (endTime === null) return;

    var now = Date.now();
    var t = endTime - now;

    // Récupère les éléments à chaque tick pour gérer les ajouts dynamiques
    var nodes = document.querySelectorAll(".countdown");
    if (!nodes.length) return;

    // Init les nouveaux éléments
    nodes.forEach(buildCountdown);

    if (t <= 0) {
      // Expired
      stopEngine();
      nodes.forEach(function (el) { el.classList.add("expired"); });
      document.dispatchEvent(new CustomEvent("vx:promo-expired", {
        detail: { expiredAt: now, expirationISO: new Date(endTime).toISOString() }
      }));
      return;
    }

    // Calcul UNE SEULE FOIS pour tous les éléments
    var totalSec = (t / 1000) | 0;
    var d = (totalSec / 86400) | 0; totalSec %= 86400;
    var h = (totalSec / 3600)  | 0; totalSec %= 3600;
    var m = (totalSec / 60)    | 0;
    var s = totalSec % 60;

    var pd = pad2(d);
    var ph = pad2(h);
    var pm = pad2(m);
    var ps = pad2(s);

    nodes.forEach(function (el) {
      var refs = el.__vx;
      if (!refs) return;

      // Mise à jour uniquement si la valeur change → évite les repaints inutiles
      if (refs.noDays) {
        var hTotal = pad2(d * 24 + h);
        if (refs.h && refs.h.textContent !== hTotal) refs.h.textContent = hTotal;
      } else {
        if (refs.d && refs.d.textContent !== pd) refs.d.textContent = pd;
        if (refs.h && refs.h.textContent !== ph) refs.h.textContent = ph;
      }
      if (refs.m && refs.m.textContent !== pm) refs.m.textContent = pm;
      if (refs.s && refs.s.textContent !== ps) refs.s.textContent = ps;
    });
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  FREEZE : rendu statique (ex: pages accès privé avant inscription)
  //  - n'initialise pas __vxInited : le vrai moteur pourra reconstruire
  //    l'élément normalement dès qu'il démarre (startEngine / vx:countdown)
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  function freezeCountdown(days) {
    var pd = pad2(days);
    document.querySelectorAll(".countdown").forEach(function (el) {
      if (el.__vxInited) return;
      var noDays = el.getAttribute("data-no-days") === "false";
      el.innerHTML =
        '<div class="vx-countdown">' +
        (!noDays
          ? '<div class="vx-box"><span class="vx-num vx-d">' + pd + '</span><span class="vx-lab">J</span></div>'
          : "") +
        '<div class="vx-box"><span class="vx-num vx-h">00</span><span class="vx-lab">H</span></div>' +
        '<div class="vx-box"><span class="vx-num vx-m">00</span><span class="vx-lab">M</span></div>' +
        '<div class="vx-box"><span class="vx-num vx-s">00</span><span class="vx-lab">S</span></div>' +
        "</div>";
    });
  }

  function stopEngine() {
    if (tickerId !== null) {
      clearInterval(tickerId);
      tickerId = null;
    }
    endTime = null;
  }

  function startEngine(expirationISO) {
    var parsed = new Date(expirationISO).getTime();
    if (!isFinite(parsed)) {
      console.warn("[VX Countdown] Date invalide :", expirationISO);
      return;
    }

    // Reset les éléments déjà initialisés pour les reconstruire si nécessaire
    // (ex: changement de promo en live)
    if (endTime !== null && endTime !== parsed) {
      document.querySelectorAll(".countdown").forEach(function (el) {
        el.__vxInited = false;
        el.__vx = null;
      });
    }

    stopEngine();
    endTime = parsed;

    // Premier tick immédiat, puis toutes les secondes
    tick();
    tickerId = setInterval(tick, 1000);
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  ENREGISTREMENT DU MOTEUR SUR WINDOW
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  window.__vxCountdownEngine = { start: startEngine, stop: stopEngine, freeze: freezeCountdown };
  window.startCountdown = startEngine;
  window.freezeCountdown = freezeCountdown;

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  LISTENER EVENEMENT (branché une seule fois)
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  document.addEventListener("vx:countdown", function (e) {
    var iso = (e.detail && (e.detail.expiresAtISO || e.detail.expirationISO)) || e.detail;
    if (!iso || typeof iso !== "string") return;
    startEngine(iso);
  });

})();